import { ContentPlayback } from '../model/ContentPlayback';
import { useContentCard } from '../model/useContentCard';
import NewIcon from '@/assets/icons/new.png';
import PremiumIcon from '@/assets/icons/premium-locked.png';
import { Expose } from '@/shared/ui';
import { Content } from '@/types';
import { formatSecondsToHMS } from '@/utils';
import isNil from 'lodash/isNil';

export type MovieContentCardProps = {
  sourcePage: string;
  content: Content;
  tabIndex: number;
  focusKey?: string;
  onFocused?: ({ x, top }: { x: number; top: number }) => void;
  weight: number;
  containerId?: number;
  topicId?: number;
};

export const MovieContentCard = ({
  sourcePage,
  content,
  tabIndex,
  focusKey,
  onFocused,
  weight,
  containerId,
  topicId,
}: MovieContentCardProps) => {
  const { ref, progress, handleClick, handleExposed } = useContentCard({
    content,
    sourcePage,
    weight,
    focusKey,
    containerId,
    topicId,
    onFocused,
  });

  return (
    <Expose
      className="w-[360px] h-[522px] mr-[20px] mb-[20px] relative overflow-hidden ease-in-out duration-300 rounded-[20px] outline-disable outline-primary-12 bg-gray-400"
      targetRef={ref}
      onExposed={handleExposed}
      threshold={Number.EPSILON}
      tabIndex={tabIndex}
      onClick={handleClick}
      onContextMenu={handleClick}
    >
      {/* 썸네일 */}
      <img
        src={content.thumbnail}
        className="w-full h-full absolute object-cover rounded-[20px]"
        loading="lazy"
        width={360}
        height={522}
      />

      {/* 유료 콘텐츠 스티커 */}
      {ContentPlayback.isLocked(content) && (
        <img src={PremiumIcon} className="absolute top-[10px] right-[10px]" width={58} height={58} />
      )}

      {/* 신규 콘텐츠 스티커 */}
      {content.sticker === 'NEW' && <img src={NewIcon} className="absolute top-[10px] left-[10px] w-[73px] h-[34px]" />}

      {/* 영상 재생 시간 */}
      {!isNil(content.duration) && content.duration > 0 && (
        <span className="absolute bg-[rgba(0,0,0,0.3)] bottom-[10px] right-[10px] rounded-[5px] text-[16px] px-[10px] py-[2px] text-white">
          {formatSecondsToHMS(content.duration)}
        </span>
      )}

      {/* 시청 이력 */}
      {progress > 0 && (
        <div className="absolute bottom-0 left-0 h-[8px] bg-secondary" style={{ width: `${progress}%` }} />
      )}
    </Expose>
  );
};
